<div class="container-fluid mt-3">
    <app-speed-dial-fab (clicked)="dispatch($event)" [options]="FabOptions"></app-speed-dial-fab>

    <div class="row justify-content-center">
        <h4 class="text-center"> Statut: {{ getAnalysisStatusName(model.Status)}}</h4>
    </div>

    <div class="row">
        <mat-form-field class="col">
            <mat-chip-grid #chipList aria-label="Analyste" [disabled]="model.Status === AnalyseStatut.Done">
                <mat-chip *ngFor="let u of model.AnalyserList" [selectable]="selectable" removable="true" (removed)="removeAnalyser(u)" >
                    {{u.Fullname}}
                    <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
                <input #analyste Input placeholder="Analystes..."
                       [matChipInputFor]="chipList"
                       [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                       [matAutocomplete]="auto"
                       [matChipInputAddOnBlur]="addOnBlur">
            </mat-chip-grid>
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedAnalyser($event)">
                <mat-option *ngFor="let u of AllUserList" [value]="u">
                    {{u.Fullname}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="col">
            <mat-label>Date d'analyse</mat-label>
            <input matInput placeholder="Date d'analyse" [matDatepicker]="picker" [(ngModel)]="model.Date" (focus)="picker.open()" [disabled]="model.Status === AnalyseStatut.Done">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="col">
            <mat-label>Durée d'analyse</mat-label>
            <input matInput placeholder="Durée d'analyse" type="number" [(ngModel)]="model.Duration" [disabled]="model.Status === AnalyseStatut.Done">
        </mat-form-field>
    </div>

    <div class="row">
        <h2 class="ps-5">Unité de Relevé 1</h2>
        <div class="col-12 col-md-4 col-xl-2 my-3" *ngFor="let t of UR1TaxonList">
            <div class="h-100 m-1">
                <div class="border rounded-1 background-light p-3 w-100 h-100 d-flex flex-column" [class.background-orange]="t.Preleve" [class.background-violet-accent]="!t.Preleve">

                    <div class="row">
                        <h3 class="text-center" [matTooltip]="t.Comment" [matTooltipDisabled]="t.Comment !== undefined && t.Comment !== ''">
                            {{t.Code}}
                        </h3>
                    </div>

                    <!-- <div class="card-body p-2"> -->
                    <div class="text-center"> {{t.NomOrdre}}</div>
                    <div class="text-center"> {{t.NomFamille}}</div>
                    <div class="text-center"> {{t.NomGenre}}</div>

                    <div class="text-center"> {{t.CustomName}}</div>
                    <div *ngIf="t.NumeroPrelevement" class="text-center"> N° {{t.NumeroPrelevement}}</div>

                    <div class="text-center fst-italic"> {{t.Comment}}</div>
                    <div class="row justify-content-center align-items-center m-3">
                        <div *ngIf="!t.Presence" class="col-auto h2 fw-bold"> {{t.Quantite | number: '1.1-2' }} %</div>
                        <div *ngIf="t.Presence">&#62;0.01</div>
                    </div>

                    <div *ngIf="t.CustomName" class="row justify-content-center text-center m-3">
                        <div class="col-auto">

                            <button appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="openTaxonIdentifyBox(t)">
                                Identifier
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="UR2TaxonList.length > 0" class="px-5 py-3">
            <mat-divider  style="--mat-divider-width: 5px;"></mat-divider>
        </div>

        <h2 *ngIf="UR2TaxonList.length > 0" class="ps-5">Unité de Relevé 2</h2>
        <div class="col-12 col-md-4 col-xl-2 my-3" *ngFor="let t of UR2TaxonList">
            <div class="h-100 m-1">
                <div class="border rounded-1 background-light p-3 w-100 h-100 d-flex flex-column" [class.background-orange]="t.Preleve" [class.background-violet-accent]="!t.Preleve">

                    <div class="row">
                        <h3 class="text-center" [matTooltip]="t.Comment" [matTooltipDisabled]="t.Comment !== undefined && t.Comment !== ''">
                            {{t.Code}}
                        </h3>
                    </div>

                    <!-- <div class="card-body p-2"> -->
                    <div class="text-center"> {{t.NomOrdre}}</div>
                    <div class="text-center"> {{t.NomFamille}}</div>
                    <div class="text-center"> {{t.NomGenre}}</div>

                    <div class="text-center"> {{t.CustomName}}</div>
                    <div *ngIf="t.NumeroPrelevement" class="text-center"> N° {{t.NumeroPrelevement}}</div>

                    <div class="text-center fst-italic"> {{t.Comment}}</div>
                    <div class="row justify-content-center align-items-center m-3">
                        <div *ngIf="!t.Presence" class="col-auto h2 fw-bold"> {{t.Quantite | number: '1.1-2' }} %</div>
                        <div *ngIf="t.Presence">&#62;0.01</div>
                    </div>

                    <div *ngIf="t.CustomName" class="row justify-content-center text-center m-3">
                        <div class="col-auto">

                            <button appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="openTaxonIdentifyBox(t)">
                                Identifier
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>